import {FC, ReactNode, useEffect, useState} from "react";
import {NewsItemFormProps} from "./types";
import {Form, Input, Spin, Switch, UploadFile} from "antd";
import "./style.less"
import {VALIDATION_MESSAGES} from "../../../../../../enums/validationMessages";
import Uploader from "../../../../../../components/uploader/Uploader";
import {useUploadController} from "../../../../../../controllers/upload-controller";
import * as BUCKETS from "../../../../../../enums/buckets"
import {getImageLink} from "../../../../../../helpers/mainHelpers";
import TextEditor from "../../../../../../components/text-editor/TextEditor";

const NewsItemForm: FC<NewsItemFormProps> = (props) => {
  const {form, createNewsHandler, isLoading, isModalOpen, selectedNewsItem, updateNewsHandler} = props
  const [uploadImages, setUploadImages] = useState<UploadFile[]>([])
  const [mainImageId, setMainImageId] = useState<string | undefined>(undefined)
  const {isFilesLoading, fetchFilesHandler, currentFiles} = useUploadController()
  const [newsContent, setNewsContent] = useState(selectedNewsItem?.body)

  const isDataLoading = isFilesLoading || isLoading


  useEffect(() => {
    if (selectedNewsItem) {
      const {title, body, images, mainImage} = selectedNewsItem
      form.setFieldsValue({title, body})
      setMainImageId(mainImage)
      fetchFilesHandler({fileIds: images, bucketId: BUCKETS.MAIN})
    } else {
      form.resetFields()
    }
  }, [selectedNewsItem])

  useEffect(() => {
    if (currentFiles.length) {
      const files = currentFiles.map((file) => {
        return {
          uid: file.$id,
          name: file.name,
          url: getImageLink({imageId: file.$id, bucketId: BUCKETS.MAIN}),
          response: {$id: file.$id}
        }
      })
      setUploadImages(files)
    }
  }, [currentFiles])


  const onMainImageSwitchChange = (props: { fileId: string, value: boolean }) => {
    const {fileId, value} = props
    if (!value) {
      setMainImageId(undefined)
    } else {
      setMainImageId(fileId)
    }
  }

  const formSubmitHandler = async (formData: { title: string, body: string }) => {
    const newsData = {
      title: formData.title,
      body: newsContent || "",
      images: uploadImages.map((image) => image.response?.$id) as unknown as string[],
      mainImage: mainImageId || ""
    }
    if (selectedNewsItem) {
      await updateNewsHandler(newsData)
    } else {
      await createNewsHandler(newsData)
    }
  }


  const customUploadItemRender = (originNode: ReactNode,
                                  file: UploadFile,
                                  fileList: UploadFile[],
                                  actions: {
                                    download: () => void;
                                    preview: () => void;
                                    remove: () => void;
                                  }
  ) => {
    return <span> {originNode} <Switch checked={file.response?.$id === mainImageId} onChange={(checked, event) => {
      onMainImageSwitchChange({fileId: file.response.$id, value: checked})

    }} size="small" checkedChildren="Головне" unCheckedChildren="Додаткове"/></span>
  }
  return <Spin spinning={isDataLoading}>
    <Form form={form} layout="vertical" className="newsItem_form" onFinish={formSubmitHandler}>
      <Form.Item label="Заголовок" name="title" rules={[{required: true, message: VALIDATION_MESSAGES.REQUIRED}]}>
        <Input/>
      </Form.Item>
      <Form.Item label="Текст новини" name="body">
        <TextEditor value={newsContent} setValue={setNewsContent}/>
      </Form.Item>
      <Form.Item label="Зображення" name="images">
        <Uploader files={uploadImages} setFiles={setUploadImages} customUploadItemRender={customUploadItemRender}
                  bucketId={BUCKETS.MAIN}/>
      </Form.Item>
    </Form>
  </Spin>
}

export default NewsItemForm